// extracted by mini-css-extract-plugin
export default {"container":"Wc9sGz","vertical":"Ckai2J"};